import type { SVGProps } from "react";
export default function SvgGoogleDrive(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			viewBox="0 0 48 48"
			{...props}
		>
			<path
				fill="#1e88e5"
				d="M38.59 39c-.535.93-.298 1.68-1.195 2.197A6 6 0 0 1 34.39 42H13.61a6 6 0 0 1-3.004-.802C9.708 40.681 9.945 39.93 9.41 39l7.67-9h13.84z"
			/>
			<path
				fill="#fbc02d"
				d="M27.463 6.999c1.073-.002 2.104-.716 3.001-.198a6 6 0 0 1 2.197 2.201l10.39 17.996c.537.93.807 1.967.808 3.002.001 1.037-1.267 2.073-1.806 3.001l-11.127-3.005-6.924-11.993z"
			/>
			<path
				fill="#e53935"
				d="M43.86 30c0 1.04-.27 2.07-.81 3l-3.67 6.35a6.05 6.05 0 0 1-1.99 1.85L30.92 30z"
			/>
			<path
				fill="#4caf50"
				d="M5.947 33.001c-.538-.928-1.806-1.964-1.806-3a6 6 0 0 1 .808-3.004l10.39-17.996a6 6 0 0 1 2.196-2.2c.897-.519 1.929.195 3.002.197l3.459 11.009-6.922 11.989z"
			/>
			<path
				fill="#1565c0"
				d="m17.08 30-6.47 11.2a6.05 6.05 0 0 1-1.99-1.85L4.95 33c-.54-.93-.81-1.96-.81-3z"
			/>
			<path
				fill="#2e7d32"
				d="M30.46 6.8 24 18 17.53 6.8c.78-.45 1.66-.73 2.6-.79L27.46 6c1.08 0 2.11.28 3 .8"
			/>
		</svg>
	);
}
